import { render, staticRenderFns } from "./colum_model.vue?vue&type=template&id=5b2fb755&scoped=true&"
import script from "./colum_model.vue?vue&type=script&lang=js&"
export * from "./colum_model.vue?vue&type=script&lang=js&"
import style0 from "./colum_model.vue?vue&type=style&index=0&id=5b2fb755&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2fb755",
  null
  
)

export default component.exports